export interface QuestLayoutConfig {
  position: { top: string; left: string }
  size?: { width: string; height: string; left: string; top: string }
  imageSize: { width: string; height: string }
  fontSize: string
  textOffset: number
}

export enum QuestViewState {
  Closed = 'closed',
  ShouldOpen = 'shouldOpen',
  Showed = 'showed',
}
